import { useState } from "react";
import { Plus, Minus } from "lucide-react";

const FAQS = [
  {
    q: "What is AI Search Optimization (GEO/AEO)?",
    a: "AI Search Optimization (also called Generative Engine Optimization or Answer Engine Optimization) is the process of making your brand visible inside AI-generated answers from ChatGPT, Gemini, Google AI Overviews, and Perplexity. Lumotis structures your content and builds citations so AI systems recommend your business when customers ask relevant questions.",
  },
  {
    q: "How long does digital marketing take to show results?",
    a: "Paid advertising (PPC) can generate measurable results within days of launch. SEO and Local SEO typically show meaningful traffic and lead growth within 3–6 months. Social media and email marketing compound over time, with strong engagement usually visible within 60–90 days of consistent execution.",
  },
  {
    q: "Does Lumotis work with all types of businesses?",
    a: "Yes. Lumotis has built proven marketing playbooks across 15+ industries including Shopify & ecommerce, real estate, salons & spas, healthcare, restaurants, finance, education, and professional services. Our approach is always tailored to your industry's buyer psychology and competitive landscape.",
  },
  {
    q: "Does Lumotis offer full-service digital marketing?",
    a: "Yes. Lumotis provides a complete digital marketing stack: AI Search Optimization (GEO/AEO), SEO, Local SEO, Paid Advertising (Google & Meta), Social Media Management, Content Marketing, Email & SMS Marketing, Marketing Automation, Website Design & Development, CRO, Video Content, and Online Reputation Management — all under one roof.",
  },
];

export default function FAQSection() {
  const [open, setOpen] = useState(0);
  return (
    <section
      id="faq"
      className="py-20 md:py-28 bg-white border-t border-zinc-100"
      itemScope
      itemType="https://schema.org/FAQPage"
      data-testid="faq-section"
    >
      <div className="container grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4">
          <p className="text-overline text-electric mb-3">11 — FAQ</p>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-charcoal text-balance">
            Frequently asked questions
          </h2>
          <p className="mt-5 text-zinc-500 leading-relaxed">
            Still have questions? Drop us a note in the audit form — a real
            strategist (not a bot) replies within 24h.
          </p>
        </div>

        <ul className="lg:col-span-8 border-t border-zinc-100">
          {FAQS.map((f, idx) => {
            const isOpen = open === idx;
            return (
              <li
                key={f.q}
                className="border-b border-zinc-100"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                data-testid={`faq-item-${idx}`}
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : idx)}
                  className="w-full py-6 flex items-center justify-between gap-6 text-left"
                  aria-expanded={isOpen}
                  data-testid={`faq-toggle-${idx}`}
                >
                  <span
                    className="font-display text-lg md:text-xl font-semibold text-charcoal"
                    itemProp="name"
                  >
                    {f.q}
                  </span>
                  <span className={`w-9 h-9 grid place-items-center rounded-xl flex-shrink-0 transition-colors ${isOpen ? "bg-electric text-white" : "bg-zinc-50 border border-zinc-200 text-charcoal"}`}>
                    {isOpen ? (
                      <Minus className="w-4 h-4" />
                    ) : (
                      <Plus className="w-4 h-4" />
                    )}
                  </span>
                </button>
                {isOpen && (
                  <div
                    className="pb-6 text-zinc-500 leading-relaxed"
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                  >
                    <p itemProp="text">{f.a}</p>
                  </div>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
